const CryptoJS = require("crypto-js");

export default function EncryptData(plainText: string, secret: string) {
    var secretKey = secret.substring(0, 16);
    var key = CryptoJS.enc.Utf8.parse(secretKey);
    var iv = CryptoJS.enc.Utf8.parse(secretKey);

    var cipherText = CryptoJS.AES.encrypt(plainText, key
        , {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }
    );
    // console.log("Encrypted Text : " + cipherText.toString());

    return cipherText;
}

export function Decrypt(cipherText: string, secret: string) {
    var secretKey = secret.substring(0, 16);
    var key = CryptoJS.enc.Utf8.parse(secretKey);
    var iv = CryptoJS.enc.Utf8.parse(secretKey);

    var decryptText = CryptoJS.AES.decrypt(cipherText, key
        , {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }
    );

    // console.log("Decrypted Text : " + decryptText.toString(CryptoJS.enc.Utf8));
    return decryptText.toString(CryptoJS.enc.Utf8);
}


export function base64Encode(plainText: string) {
    return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(plainText));
}

export function fromBase64ToString(data : string) {
    data = data.replace(/[^A-Za-z0-9+/=]/g, '');

    const padding = data.length % 4;
    if (padding !== 0) {
        data += '='.repeat(4 - padding);
    }

    try {
        return atob(data);
    } catch (e) {
        console.error("Invalid Base64 string:", data);
        throw new Error("Invalid Base64 input.");
    }
}


export function encryptCardAES256(data: string, key: string) {
    try {
        key = key.substring(0, 32);
        const iv = CryptoJS.enc.Utf8.parse(key.substring(0, 16));
        const keyWordArray = CryptoJS.enc.Utf8.parse(key);


        const encrypted = CryptoJS.AES.encrypt(data, keyWordArray, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        return encrypted.toString();
    } catch (error) {
        console.error('Encryption error:', error);
        return null;
    }
}

export function DecryptAES256(cipherText: string, secret: string) {
    var secretKey = secret.substring(0, 32);
    var iv = CryptoJS.enc.Utf8.parse(secretKey.substring(0, 16));
    var key = CryptoJS.enc.Utf8.parse(secretKey);

    var decryptText = CryptoJS.AES.decrypt(cipherText, key
        , {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }
    );

    // console.log("Decrypted Text : " + decryptText.toString(CryptoJS.enc.Utf8));
    return decryptText.toString(CryptoJS.enc.Utf8);
}

